// removed by extract-text-webpack-plugin
module.exports = {"shadow1":"_23ViYxc_GWeuzc7pJhM5nb","baseUnitValue":"8px","colorWhite":"#fff","flyout":"_2Jh0CTShNLapSmEUUjCVyS _23ViYxc_GWeuzc7pJhM5nb","flyoutContainer":"_2oryalyh4RfpGECMQq8ka4","flyoutContainerContent":"_2vIz8vX7CvBBWRIBVCZCNA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/flyout/flyout.css
// module id = 435
// module chunks = 0